import { Box } from '@chakra-ui/react';
import AuthService from 'api/services/AuthService';
import InputMy from 'components/InputMy';
import PasswordStrength from 'components/PasswordStrength';
import AuthButton from 'components/singIn/AuthButton';
import Subtitle from 'components/singIn/Subtitle';
import Title from 'components/singIn/Title';
import DefaultAuth from 'layouts/auth/Default';
import showMessage from 'providers/NoticeProvider/showMessage';
import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { SIGN_OUT } from 'routes';

const PasswordReset = () => {
    const [params] = useSearchParams();
    const [loading, setLoading] = useState(false);
    const [disabled, setDisabled] = useState(true);
    const [password, setPassword] = useState('');

    const handleSubmit = async () => {
        try {
            setLoading(true);
            await AuthService.resetChange({
                token: params.get('token'),
                password,
            })
                .then(response => {
                    showMessage('Password changed');
                    setTimeout(() => {
                        window.location = SIGN_OUT.fullPath as unknown as Location;
                    }, 1000);
                    console.log('response', response);
                })
                .finally(() => {
                    setLoading(false);
                });
        } catch (e) {
            return false;
        }
    };

    return (
        <DefaultAuth>
            <Box>
                <Title>Set a new password</Title>
                <Subtitle>Enter a new password below to change your password</Subtitle>
                <InputMy
                    type="password"
                    value={password}
                    onChangeValue={setPassword}
                    label="New Password"
                    placeholder="password"
                    sx={{ mb: '16px' }}
                />
                <PasswordStrength password={password} setDisabled={setDisabled} />
                <AuthButton isDisabled={disabled} loading={loading} onClick={handleSubmit}>
                    Set new password
                </AuthButton>
            </Box>
        </DefaultAuth>
    );
};

export default PasswordReset;
